import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { BookOpen, Award } from 'lucide-react';
export const HouseOfLionsSection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section id="house-of-lions" ref={sectionRef} className="py-20 md:py-28 bg-black relative overflow-hidden" style={{
    opacity
  }} data-id="element-1550" data-mp="1niklovckzx79">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/5 to-black z-0" data-id="element-1551" data-mp="1dshtgxdaan9z"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-1552" data-mp="1iqawjhjaj161">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-1553" data-mp="1ioq1zrwz7i86">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-1554" data-mp="qsnpjwar4qh4">
            The Chronicle Behind The Journey
          </p>
          <h2 className="font-serif text-5xl md:text-7xl text-white mb-8" data-id="element-1555" data-mp="15iv6u8p0w3g8">
            HOUSE OF
            <br data-id="element-1556" data-mp="10nz3icec5tnt" />
            <span className="text-amber-400" data-id="element-1557" data-mp="1ehgmnw3414db">LIONS</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto" data-id="element-1558" data-mp="1efm0yfk0l886"></div>
        </motion.div>
        <div className="max-w-6xl mx-auto" data-id="element-1559" data-mp="19hu9fmna7o4i">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start" data-id="element-1560" data-mp="1ofml23ppjsdf">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="lg:col-span-2" data-id="element-1561" data-mp="1odjwzp8489bc">
              <div className="relative max-w-sm mx-auto lg:mx-0" data-id="element-1562" data-mp="is9kvdeawg8n">
                <div className="relative rounded-lg overflow-hidden border-2 border-amber-400/20" data-id="element-1563" data-mp="isjbn3766rfe">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/t3CRbn4AkSTsAZ7KzhK5CV/Book_cover.webp" alt="House of Lions Book Cover" className="w-full h-auto" data-id="element-1564" data-mp="nq18vwbtri7k" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" data-id="element-1565" data-mp="11qlwr6wlk47x"></div>
                </div>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="lg:col-span-3 space-y-8" data-id="element-1566" data-mp="1bgnjnvd7rgl9">
              <div className="border-l-2 border-amber-400/30 pl-6" data-id="element-1567" data-mp="30xsqb37mfjde">
                <p className="text-2xl text-amber-400 font-light italic mb-2" data-id="element-1568" data-mp="2vyzb96corkb4">
                  "Every great kingdom deserves its chronicle."
                </p>
              </div>
              <div className="space-y-4" data-id="element-1569" data-mp="2r28z2u4058uz">
                <p className="text-white/80 text-lg leading-relaxed font-light" data-id="element-1570" data-mp="3onwlcm6quass">
                  <span className="text-amber-400 font-serif text-xl" data-id="element-1571" data-mp="3jotmxkl9r2ts">
                    House of Lions: Life in the Sikh Kingdoms
                  </span>{' '}
                  is the forthcoming historical epic that inspired this
                  immersive dining experience.
                </p>
                <p className="text-white/70 leading-relaxed font-light" data-id="element-1572" data-mp="b9a0p5j0mko8">
                  Co-created with a producer credited on HBO's Game of Thrones
                  and written by A.K. Singh, this book traces the vision, valor,
                  and unity that defined Maharaja Ranjit Singh's empire — the
                  same spirit brought to life here through sound, flavor, and
                  light.
                </p>
              </div>
              <div className="border-2 border-amber-400/30 p-6 bg-black/40" data-id="element-1573" data-mp="3d91m2e6k8wa8">
                <div className="flex items-start gap-4" data-id="element-1574" data-mp="3i737v6vdf9pe">
                  <div className="flex-shrink-0" data-id="element-1575" data-mp="9qrx20xxtu32">
                    <div className="w-12 h-12 rounded-full bg-amber-400/10 flex items-center justify-center border border-amber-400/30" data-id="element-1576" data-mp="9r095qm8kvd7">
                      <BookOpen className="w-6 h-6 text-amber-400" data-id="element-1577" data-mp="osd3hgerow" />
                    </div>
                  </div>
                  <div data-id="element-1578" data-mp="4z9uj8g9nlfz">
                    <h4 className="text-lg font-serif text-amber-400 mb-2" data-id="element-1579" data-mp="4yqfbzi03b5n">
                      Exclusive Author Meet & Greet
                    </h4>
                    <p className="text-white/70 text-sm font-light leading-relaxed" data-id="element-1580" data-mp="xg2ogrteec4j">
                      Guests at Life in the Sikh Kingdoms will have an exclusive
                      opportunity to meet the author during both evenings of the
                      event and receive a personally signed pre-release edition
                      of House of Lions.
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap gap-4 pt-4" data-id="element-1581" data-mp="2myj72mremsyv">
                <div className="flex items-center gap-2 text-white/60 text-sm" data-id="element-1582" data-mp="1z7ds09tag4pm">
                  <Award className="w-4 h-4 text-amber-400" data-id="element-1583" data-mp="1u8ivy66b8jnk" />
                  <span className="font-light" data-id="element-1584" data-mp="1ua3qhvsmk2lf">
                    HBO Game of Thrones Producer
                  </span>
                </div>
                <div className="flex items-center gap-2 text-white/60 text-sm" data-id="element-1585" data-mp="246qbqlov4vnz">
                  <BookOpen className="w-4 h-4 text-amber-400" data-id="element-1586" data-mp="248t7znglzl15" />
                  <span className="font-light" data-id="element-1587" data-mp="3jm5uxwaex30p">Historical Epic</span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.section>;
};